import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginScreen } from '../pages/LoginScreen';
import PageContainer from '../pages/PageContainer';
import ProtectedRoute from '../utils/ProtectedRoute';
import NotFoundPage from '../pages/NotFoundPage';
import { useAuth } from '../context/AuthContext';
import MaterialDetailPage from '../pages/Learnings/StudyMaterial/MaterialDetailPage';

const Router = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginScreen />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<PageContainer />} />
        
        {/* Profile routes */}
        <Route path="/profile" element={<PageContainer />} />
        <Route path="/profile/fees" element={<PageContainer />} />
        <Route path="/profile/certificate" element={<PageContainer />} />
        <Route path="/profile/change-password" element={<PageContainer />} />
        
        {/* Learning routes */}
        <Route path="/learning/*" element={<PageContainer />} />
        
        {/* Material detail route */}
        <Route path="/learning/materials/material" element={<PageContainer />} />
        
        {/* Other routes */}
        <Route path="/reports" element={<PageContainer />} />
        <Route path="/announcements" element={<PageContainer />} />
        <Route path="/chat" element={<PageContainer />} />
      </Route>

      {/* Root route */}
      <Route path="/" element={
        isAuthenticated ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />
      } />

      {/* Catch-all route for unauthenticated users */}
      <Route path="*" element={
        isAuthenticated ? <NotFoundPage /> : <Navigate to="/login" replace />
      } />
    </Routes>
  );
};

export default Router;